import React from 'react';
import cn from 'classnames';
import Icon from '../Icon';
export var AssetIcon = function(props) {
    var product = props.product, defaultIcon = props.defaultIcon, classNames = props.classNames, _props_roundedCorners = props.roundedCorners, roundedCorners = _props_roundedCorners === void 0 ? true : _props_roundedCorners;
    return /*#__PURE__*/ React.createElement(Icon, {
        className: cn('AssetIcon', {
            inverted: product
        }, classNames),
        isCornerRound: roundedCorners,
        icon: product || defaultIcon || 'clip'
    });
};
export default AssetIcon;
